import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateCollectiveGroup({ username, onClose, onJobC_ID, getCollective }) {

    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        comment: "",
        user_transaction: username,
        est_id: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        const getMetal = async () => {
            try {
                const response = await axios.get(`${server_backend}/collective/select?id=${onJobC_ID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        comment: data.comment,
                        user_transaction: username,
                        id: onJobC_ID,
                        est_id: data.est_ID
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        getMetal();
    }, [onJobC_ID, username]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

        try {
            const response = await axios.post(`${server_backend}/collective/update`, formData, headers);
            setLoading(true);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Updated Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });

                onClose();
                getCollective();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Collective Groups already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    }});
    };

    return (
        <div className="row">
            <div className="card">
                <div className="card-header align-items-center d-flex">
                    <div className="col-md-12">
                        <div className="text-end">
                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        onClose();
                                    }
                                }
                                )
                            }
                            }>Discard Change</Link>
                            <Link to="#" onClick={handleUpdate} className="btn btn-primary">
                                {loading ? "Loading..." : "Update"}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="card-header">
                    <center>
                        <h4>Collective Groups</h4>
                    </center>
                </div>

                <div className="modal-body">
                    <form onSubmit={handleUpdate}>
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <label htmlFor="name" className="form-label">ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter metal name"
                                    name="name"
                                    value={onJobC_ID}
                                    disabled
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="name" className="form-label">Name <span style={{ color: 'red' }}>*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter metal name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    
                                />
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="user_transaction" className="form-label">Status <span style={{ color: 'red' }}>*</span></label>
                                    <select
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        name="est_id"
                                        value={formData.est_id}
                                        onChange={handleChange}
                                        required
                                    >
                                        {formData.est_id === 1 ? (
                                            <>
                                                <option value="1">Activated</option>
                                                <option value="2">Disabled</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="2">Disabled</option>
                                                <option value="1">Activated</option>
                                            </>
                                        )}
                                    </select>
                                </div>
                                <br />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label htmlFor="comment" className="form-label">Comment</label>
                                <textarea
                                    className="form-control"
                                    placeholder="Enter comment"
                                    name="comment"
                                    value={formData.comment}
                                    onChange={handleChange}
                                ></textarea>
                            </div>

                            <h4 className='p-3'>Other Information</h4>
                            <div className="col-6 mb-3">
                                <label htmlFor="date_created" className="form-label">Date Created</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={vAdminformat.FormatDate(dateCreated)}
                                    disabled
                                />
                            </div>
                            <div className="col-6  mb-3">
                                <label htmlFor="user_transaction" className="form-label">User Created</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.user_transaction}
                                    disabled
                                />
                            </div>

                            <div className="col-6  mb-3">
                                <label htmlFor="date_modify" className="form-label">Date Modified</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={dateModify && vAdminformat.FormatDate(dateModify)}
                                    disabled
                                />
                            </div>
                            <div className="col-6  mb-3">
                                <label htmlFor="user_created" className="form-label">User Modified</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={userModify}
                                    disabled
                                />
                            </div>

                        </div>

                        <div className="card-header align-items-center d-flex">
                            <div className="col-md-12">
                                <div className="text-end">
                                <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Alert',
                                    text: "Are you sure you want to discard these changes?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Accept',
                                    cancelButtonText: "Cancel"
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        onClose();
                                    }
                                }
                                )
                            }
                            }>Discard Change</Link>
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Updating..." : "Update"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default UpdateCollectiveGroup;
